module.exports = __webpack_public_path__ + "static/media/status-success-white.70efc788.svg";